import React from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";

import Sidebar from "../Sidebar";
import Topbar from "../Topbar";
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  SIDEBAR_TRANSITION_MS,
  createDashboardTheme,
} from "../../theme/dashboardShell";

const dashboardTheme = createDashboardTheme();

const STORAGE_KEY = "assetOwnerSidebarCollapsed";

export default function DashboardLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const toggleSidebar = React.useCallback(() => {
    setSidebarCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const drawerWidth = sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <ThemeProvider theme={dashboardTheme}>
      <CssBaseline />
      <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={toggleSidebar} />
      <Box
        sx={{
          ml: `${drawerWidth}px`,
          width: `calc(100% - ${drawerWidth}px)`,
          minHeight: "100dvh",
          bgcolor: "background.default",
          display: "flex",
          flexDirection: "column",
          transition: (t) =>
            t.transitions.create(["margin", "width"], {
              easing: t.transitions.easing.sharp,
              duration: SIDEBAR_TRANSITION_MS,
            }),
        }}
      >
        <Topbar />

        <Box sx={{ p: { xs: 2, sm: 3 }, flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
